import React from 'react'
import styled from 'styled-components'
import ButtonInternalLink from './ButtonInternalLink'

const Container = styled.div`
  a {
    height: auto;
    padding: 0.5rem;
    max-width: 3rem;
    max-height: 3rem;
  }
  .home-logo-svg {
    /* width: auto; */
    /* height: 3rem; */
    width: 2rem;
    height: 2rem;
    path {
      fill: white;
    }
  }

  @media (max-width: 768px) {
    a {
      /* background-color: red !important; */
    }
  }
`

const ButtonHome = () => {
  return (
    <Container>
      <ButtonInternalLink
        size="regular"
        hoverable={true}
        btnStyle={{
          background: 'var(--color-black)',
          padding: '0.5rem',
          display: 'block',
          height: 'auto',
        }}
        path="/"
      >
        {/* <svg
          className="home-logo-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <g
            id="Gruppe_470"
            data-name="Gruppe 470"
            transform="translate(-10 -61)"
          >
            <path
              fill="white"
              id="Pfad_1391"
              data-name="Pfad 1391"
              d="M-41-33.7h1.788c.041.366.325.609.813.609s.813-.244.813-.731-.341-.731-.934-.731a6.76,6.76,0,0,0-2.072.366h-.041l.366-3.371h3.981v1.218h-2.494l-.065.569h.447c1.422,0,2.6.488,2.6,1.95,0,1.1-.894,1.829-2.6,1.829s-2.478-.853-2.6-1.707m-6.671-12.314c0,.975-.813,1.259-1.909,1.259H-53.24v-5.688h3.656c1.1,0,1.909.284,1.909,1.259v.569c0,.593-.447.869-1.04.991.593.154,1.04.447,1.04,1.04Zm0,6.32c0,.975-.813,1.26-1.909,1.26H-53.24v-5.688h3.656c1.1,0,1.909.285,1.909,1.26v.568c0,.594-.447.869-1.04.992.593.154,1.04.447,1.04,1.04Zm0,6.32c0,.975-.813,1.26-1.909,1.26H-53.24v-5.688h3.656c1.1,0,1.909.284,1.909,1.259v.569c0,.593-.447.869-1.04.991.593.154,1.04.447,1.04,1.04Zm6.419-11.38h-4.956v-.934l2.356-1.828c.52-.4.731-.731.731-1.1a.556.556,0,0,0-.609-.609.617.617,0,0,0-.691.609h-1.788c.041-.853.894-1.706,2.478-1.706s2.478.731,2.478,1.706c0,1.1-.9,1.576-1.584,2.031l-.853.569v.041h2.438Zm0,6.32h-4.956v-.935l2.356-1.828c.52-.4.731-.732.731-1.1a.556.556,0,0,0-.609-.609.616.616,0,0,0-.691.609h-1.788c.041-.853.894-1.706,2.478-1.706s2.478.732,2.478,1.706c0,1.1-.9,1.576-1.584,2.031l-.853.569v.041h2.438Zm0,6.32h-4.956v-.934l2.356-1.829c.52-.4.731-.731.731-1.1a.556.556,0,0,0-.609-.609.616.616,0,0,0-.691.609h-1.788c.041-.854.894-1.707,2.478-1.707s2.478.732,2.478,1.707c0,1.1-.9,1.576-1.584,2.031l-.853.568v.041h2.438Zm4.488-15.361a1.323,1.323,0,0,1,1.008,1.259c0,.975-.894,1.584-2.6,1.584s-2.478-.853-2.6-1.706h1.788c.041.366.325.609.813.609s.772-.244.772-.609-.325-.488-.813-.488h-1.1v-1.3h1.1c.488,0,.813-.122.813-.488s-.284-.609-.772-.609-.772.244-.813.609h-1.788c.122-.853.894-1.706,2.6-1.706s2.6.609,2.6,1.584a1.323,1.323,0,0,1-1.008,1.259m1.347,8.066h-.813v.975H-37.98v-.975h-3.047v-1.341l2.356-3.128h2.438v3.128h.813Zm-4.144-1.341h1.584v-2.178Zm-9.938,7.01v-.2c0-.244-.122-.366-.488-.366h-1.422v.934h1.422c.366,0,.488-.122.488-.366m0-2.234v-.2c0-.244-.122-.365-.488-.365h-1.422v.934h1.422c.366,0,.488-.122.488-.365m0-4.085v-.2c0-.243-.122-.365-.488-.365h-1.422v.934h1.422c.366,0,.488-.121.488-.365m0-2.235v-.2c0-.244-.122-.366-.488-.366h-1.422v.934h1.422c.366,0,.488-.121.488-.366m0-4.085v-.2c0-.244-.122-.366-.488-.366h-1.422v.934h1.422c.366,0,.488-.122.488-.366m0-2.234v-.2c0-.244-.122-.366-.488-.366h-1.422v.934h1.422c.366,0,.488-.122.488-.366"
              transform="translate(69.33 117.221)"
            />
          </g>
        </svg> */}
        <svg
          className="home-logo-svg"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 17.8 18.4"
        >
          <g transform="translate(-10 -61)">
            <path
              d="M22.2,77.7H24c0,0.4,0.3,0.6,0.8,0.6s0.8-0.2,0.8-0.7s-0.3-0.7-0.9-0.7c-0.7,0-1.4,0.1-2.1,0.4
		h0l0.4-3.4h4v1.2h-2.5l-0.1,0.6h0.4c1.4,0,2.6,0.5,2.6,2c0,1.1-0.9,1.8-2.6,1.8S22.4,78.6,22.2,77.7 M15.6,65.4
		c0,1-0.8,1.3-1.9,1.3H10V61h3.7c1.1,0,1.9,0.3,1.9,1.3v0.6c0,0.6-0.4,0.9-1,1c0.6,0.2,1,0.4,1,1L15.6,65.4z M15.6,71.7
		c0,1-0.8,1.3-1.9,1.3H10v-5.7h3.7c1.1,0,1.9,0.3,1.9,1.3v0.6c0,0.6-0.4,0.9-1,1c0.6,0.2,1,0.4,1,1L15.6,71.7z M15.6,78.1
		c0,1-0.8,1.3-1.9,1.3H10v-5.7h3.7c1.1,0,1.9,0.3,1.9,1.3v0.6c0,0.6-0.4,0.9-1,1c0.6,0.2,1,0.4,1,1L15.6,78.1z M22,66.7h-5v-0.9
		l2.4-1.8c0.5-0.4,0.7-0.7,0.7-1.1c0-0.3-0.2-0.6-0.5-0.6c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.2-0.7,0.5c0,0,0,0,0,0.1H17
		c0-0.9,0.9-1.7,2.5-1.7s2.5,0.7,2.5,1.7c0,1.1-0.9,1.6-1.6,2l-0.9,0.6v0H22V66.7z M22,73h-5v-0.9l2.4-1.8c0.5-0.4,0.7-0.7,0.7-1.1
		c0-0.3-0.2-0.6-0.5-0.6c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.2-0.7,0.5c0,0,0,0,0,0.1H17c0-0.9,0.9-1.7,2.5-1.7s2.5,0.7,2.5,1.7
		c0,1.1-0.9,1.6-1.6,2l-0.9,0.6v0H22V73z M22,79.3h-5v-0.9l2.4-1.8c0.5-0.4,0.7-0.7,0.7-1.1c0-0.3-0.2-0.6-0.5-0.6c0,0-0.1,0-0.1,0
		c-0.3,0-0.6,0.2-0.7,0.5c0,0,0,0,0,0.1H17c0-0.9,0.9-1.7,2.5-1.7s2.5,0.7,2.5,1.7c0,1.1-0.9,1.6-1.6,2l-0.9,0.6v0H22V79.3z
		 M26.5,64c0.6,0.1,1,0.7,1,1.3c0,1-0.9,1.6-2.6,1.6s-2.5-0.9-2.6-1.7h1.8c0,0.4,0.3,0.6,0.8,0.6s0.8-0.2,0.8-0.6s-0.3-0.5-0.8-0.5
		h-1.1v-1.3h1.1c0.5,0,0.8-0.1,0.8-0.5s-0.3-0.6-0.8-0.6s-0.8,0.2-0.8,0.6h-1.8c0.1-0.9,0.9-1.7,2.6-1.7s2.6,0.6,2.6,1.6
		C27.5,63.3,27.1,63.8,26.5,64 M27.8,72H27v1h-1.8v-1h-3v-1.3l2.4-3.1H27v3.1h0.8L27.8,72z M23.7,70.7h1.6v-2.2L23.7,70.7z
		 M13.7,77.7v-0.2c0-0.2-0.1-0.4-0.5-0.4h-1.4v0.9h1.4C13.6,78.1,13.7,77.9,13.7,77.7 M13.7,75.5v-0.2c0-0.2-0.1-0.4-0.5-0.4h-1.4
		v0.9h1.4C13.6,75.8,13.7,75.7,13.7,75.5 M13.7,71.4v-0.2c0-0.2-0.1-0.4-0.5-0.4h-1.4v0.9h1.4C13.6,71.8,13.7,71.6,13.7,71.4
		 M13.7,69.2V69c0-0.2-0.1-0.4-0.5-0.4h-1.4v0.9h1.4C13.6,69.5,13.7,69.4,13.7,69.2 M13.7,65.1v-0.2c0-0.2-0.1-0.4-0.5-0.4h-1.4v0.9
		h1.4C13.6,65.4,13.7,65.3,13.7,65.1 M13.7,62.8v-0.2c0-0.2-0.1-0.4-0.5-0.4h-1.4v0.9h1.4C13.6,63.2,13.7,63.1,13.7,62.8"
            />
          </g>
        </svg>
      </ButtonInternalLink>
    </Container>
  )
}

export default ButtonHome
